import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import NavBar from "../../components/navbar/NavBar";
import {
	closeLoader,
	openLoader,
} from "../../redux/actions/loader/loaderActions";
import { useDispatch } from "react-redux";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import { openModalAndSetContent } from "../../redux/actions/modal/modalActions";
import { Link, useParams } from "react-router-dom";
import { Box, Grid } from "@mui/material";

import "./fraud.scss";
import { useHistory } from "react-router-dom";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { FraudModuleData } from "../../types/FraudTypes";
import bell from "../../assets/images/myImages/bell.webp";
import down from "../../assets/images/myImages/down.webp";
import user from "../../assets/images/myImages/user.webp";
import visa from "../../assets/images/myImages/visa.webp";
import Arrow from "../../assets/images/myImages/back icon.webp";
import exLink from "../../assets/images/myImages/external link.webp";
import nomba from "../../assets/images/myImages/Nomba Logo.webp";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { logOut } from "../../redux/actions/auth/authActions";
import { saveLoading } from "../../redux/actions/loadingState/loadingStateActions";
import useOnClickOutside from "../../util/clickOutside";
import FlaggedModal from "./FlaggedModal";
import StatusView from "../../components/StatusView/StatusView";

export const Header = ({ title }: any) => {
	const [profileModal, setProfileModal] = useState(false);

	const handleProfileModal = () => {
		setProfileModal(true);
	};
	const handleProfileModalClose = () => {
		setProfileModal(false);
	};
	const history = useHistory();
	const dispatch = useDispatch();
	const signOutHandler = () => {
		localStorage.clear();
		dispatch(logOut());
		history.push("/signIn");
		dispatch(saveLoading(false));
		handleProfileModalClose();
	};

	return (
		<>
			{" "}
			<div className="header">
				<h1>{title}</h1>
				<div className="inbox-con">
					<img src={bell} alt="bell" />
					<div className="detail" onClick={handleProfileModal}>
						<img src={user} alt="" />
						<img src={down} className="down" alt="" />
					</div>
					{profileModal && (
						<>
							{" "}
							<div className="blur" onClick={handleProfileModalClose}></div>
							<div className="profile-modal">
								<div className="profile-top">
									<h2>ITEX Integrated Services</h2>
									<a href="" onClick={signOutHandler}>
										Sign Out
									</a>
								</div>
								<div className="user">
									<div className="prefix">ru</div>
									<div className="user-info">
										<h6>Roy Unachukwu</h6>
										<p>roy.unachukwu@iisysgroup.com</p>
										<div className="view-acc">
											View account <ArrowForwardIosIcon className="icon" />
										</div>
									</div>
								</div>
							</div>
						</>
					)}
				</div>
			</div>
		</>
	);
};

const Modal = ({ close }: any) => {
	return (
		<>
			<div className="blurClose" onClick={close}></div>

			<div className="modal">
				<div className="modal-top">
					<h2>Analyse this transaction</h2>
					<CloseIcon onClick={close} />
				</div>

				<div className="modal-text">
					<p>
						You can analyse this transaction and report if the transaction is
						fraudulent or complaint
					</p>
				</div>
				<div className="modal-form">
					<p>Transaction analysis</p>
					<select>
						<option value="">This transaction is fraudulent</option>
					</select>
					<p>Analysis</p>
					<textarea placeholder="Enter your analysis..."></textarea>
					<button type="submit">Submit</button>
				</div>
			</div>
		</>
	);
};

export const Back = ({ path, pathName }: any) => {
	const history = useHistory();
	const handleBackTofraud = (path: string) => {
		history.push(path);
	};
	return (
		<div className="back" onClick={() => handleBackTofraud(path)}>
			<img src={Arrow} alt="arrow" />
			{pathName}
		</div>
	);
};
const FraudDetails = () => {
	interface ParamTypes {
		id: string;
	}

	const { id } = useParams<ParamTypes>();

	const dispatch = useDispatch();

	const [fraud, setFraud] = useState<any>();

	// fraud by id
	const getFraudMgt = async () => {
		dispatch(openLoader());
		try {
			const data = await axios.get<any>(`/v1/fraudmgt/flagged/${id}`);
			setFraud(data?.data?.flagged);
		} catch (err: any) {
			dispatch(closeLoader());
			dispatch(
				openToastAndSetContent({
					toastContent: err?.response?.data?.message,
					toastType: "error",
				})
			);
		} finally {
			dispatch(closeLoader());
		}
	};

	useEffect(() => {
		getFraudMgt();
	}, [id]);
	const [modal, setModal] = useState(false);
	const handleModal = () => {
		setModal(true);
	};
	const handleModalClose = () => {
		setModal(false);
	};

	const ref = useRef<any>();

	useOnClickOutside(ref, () => setModal(false));

	const createdAt = fraud?.createdat.split(" ").slice(0, 3);
	const createdAtTime =
		fraud?.createdat?.split(" ").slice(3, 6).toString().substring(0, 4) +
		fraud?.createdat?.split(" ").slice(3, 6).toString().substring(8);
	// const createdAtTimeEdit =createdAtTime + createdAtTime.substring(8);
	// console.log({ Joy: createdAtTimeEdit });

	const editConfigHandler = () => {
		dispatch(
			openModalAndSetContent({
				modalStyles: {
					padding: 0,
				},
				modalContent: (
					<div>
						<FlaggedModal id={id} />
					</div>
				),
			})
		);
	};
	return (
		<>
			<div className="container" ref={ref}>
				<NavBar name="Fraud Management" padding="0" top="6.5%" />

				{fraud ? (
					<>
						<div className="margin">
							<Back path="/fraudmgt" pathName="Back to Fraud management" />
						</div>
						<div className="card transaction" ref={ref}>
							<div className="amount">
								<div className="status-con">
									<h2>{fraud?.activity}</h2>
									<StatusView
										status={fraud?.priority.toLowerCase()}
										orange="medium"
										red="high"
										newOrange="low"
									/>
								</div>
								{fraud && fraud?.user.length === 0 && (
									<div className="btn-con">
										<div
											className="analyse"
											onClick={() => editConfigHandler()}
										>
											Analyse transaction
										</div>
										{modal && <Modal close={handleModalClose} />}
									</div>
								)}
							</div>
							<div className="trans-info">
								<div>
									<p>Date created</p>
									<p>
										{createdAt} <span>{createdAtTime}</span>
									</p>
								</div>
								<div>
									<p>Payment ID</p>
									<p>{fraud?.paymentid}</p>
								</div>
								<div>
									<p>Activity</p>
									<p>{fraud?.flag}</p>
								</div>
								<div>
									<p>Card Number</p>
									<p>{fraud?.masked}</p>
								</div>
								{/* <div>
							<p>Identifier</p>
							<p>{fraud?.customer?.identifier}</p>
						</div> */}
							</div>
						</div>

						<div className="card activity-info">
							<h3
								style={{
									color: "black",
									fontFamily: "Avenir",
									marginBottom: "20px",
								}}
							>
								Analyzed by
							</h3>
							<div className="priority">
								<div>
									<p>Priority</p>
									<p className="red">{fraud?.priority}</p>
								</div>
								<div>
									<p>Analysis</p>
									<p>{fraud?.analysis}</p>
								</div>
								<div>
									<p>Analysis Done By</p>
									<Link to={`/usersandpermissions/user/${fraud?.user?.id}`}>
										<p style={{ color: "blue" }}>
											{fraud?.user?.firstname + " " + fraud?.user?.lastname}
										</p>
									</Link>
									{/* <a
								href={`http://localhost:3001/usersandpermissions/user/${fraud?.user?.id}`}
							>
								<p style={{ color: "blue" }}>
									{fraud?.user?.firstname + " " + fraud?.user?.lastname}
								</p>
							</a> */}
								</div>
							</div>
						</div>
						<div className="profile">
							<div className="card business">
								<div className="top">
									{/* <img src={nomba} alt="" /> */}
									<div className="text">
										<h5 style={{ marginBottom: "0" }}>
											{fraud?.business?.tradingname.toUpperCase()}
										</h5>
										<p>{`Merchant Code: ${fraud?.business?.merchantcode}`}</p>
									</div>
									{/* <div className="status live">{fraud?.status}</div> */}
								</div>
								<div className="name-box grid">
									<p>Trading Name</p>
									<p>Nomba Limited</p>
									<p>Business Email</p>
									<p style={{ textTransform: "lowercase" }}>
										{fraud?.business.businessemail}
									</p>
								</div>
								<Link
									to={`/businesses/info/${fraud?.business?.merchantaccountid}`}
								>
									See business profile <img src={exLink} alt="edit" />
								</Link>
								{/* <a
							href={`http://localhost:3001/businesses/info/${fraud?.business?.merchantaccountid}`}
						>
							See business profile <img src={exLink} alt="edit" />
						</a> */}
							</div>
							<div className="card business">
								<div className="top">
									<h3>Customer Information</h3>
								</div>
								<div className="customer">
									<div className="user">
										<div
											style={{
												display: "flex",
												gap: "10px",
												alignItems: "center",
											}}
										>
											<div className="prefix">
												{fraud?.customer.firstname[0]}
												{fraud?.customer.lastname[0]}
											</div>
											<div className="user-info">
												<h6>
													{fraud?.customer.firstname} {fraud?.customer.lastname}
												</h6>
												<p style={{ textTransform: "lowercase" }}>
													{fraud?.customer.email}
												</p>
											</div>
										</div>

										<div>
											<p>First name</p>
											<p>{fraud?.customer?.firstname}</p>
										</div>
										<div>
											<p>Last name</p>
											<p>{fraud?.customer?.lastname}</p>
										</div>
									</div>
									{/* <div className="iss">Blacklist customer</div> */}

									<Link to={`/customer/${fraud?.customer?.id}`}>
										See customer profile <img src={exLink} alt="edit" />
									</Link>
									{/* <a href={`http://localhost:3001/customer/${fraud?.customer?.id}`}>
								See customer profile <img src={exLink} alt="edit" />
							</a> */}
								</div>
							</div>
						</div>
					</>
				) : null}
			</div>
		</>
	);
};

export default FraudDetails;

// {
// 	/* <div className="card transaction" ref={ref}>
// 					<h3
// 						style={{
// 							color: "black",
// 							fontFamily: "Avenir",
// 							marginBottom: "20px",
// 						}}
// 					>
// 						Customer's details
// 					</h3>
// 					<div className="trans-info">
// 						<div>
// 							<p>First name</p>
// 							<p>{fraud?.customer?.firstname}</p>
// 						</div>
// 						<div>
// 							<p>Last name</p>
// 							<p>{fraud?.customer?.lastname}</p>
// 						</div>
// 						<div>
// 							<p>Customer email</p>
// 							<p>{fraud?.customer.email}</p>
// 						</div>
// 					</div>
// 				</div>
// 				<div className="card activity-info">
// 					<h3
// 						style={{
// 							color: "black",
// 							fontFamily: "Avenir",
// 							marginBottom: "20px",
// 						}}
// 					>
// 						Business's details
// 					</h3>
// 					<div className="priority">

// 						<div>
// 							<p>Trading name</p>
// 							<p>{fraud?.business?.tradingname} </p>
// 						</div>
// 						<div>
// 							<p>Merchant code</p>
// 							<p>{fraud?.business?.merchantcode} </p>
// 						</div>
// 						<div>
// 							<p>Business email</p>
// 							<p>{fraud?.business?.businessemail} </p>
// 						</div>
// 						<div>
// 							<p>MCC</p>
// 							<p>{fraud?.business?.mcc || "N/A"} </p>
// 						</div>
// 					</div>
// 				</div> */
// }

// <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
//     <NavBar name='' />

//     <Box>
//         <div className={styles.m1}>
//             <span className={styles.back} onClick={handleBackTofraud}>
//                 <ArrowLeftIcon /> Back Fraud management
//             </span>
//         </div>

//         <div className={styles.settlementDetails}>
//             <div>

//                 <Box sx={{ flexGrow: 1, margin: '0 1rem 1rem 2rem' }}>
//                     <div className={styles.mt1}>

//                         <Grid container spacing={1}>
//                             <Grid item md={2} xs={6} lg={2}>
//                                 <p className={styles.header}>Fraud id</p>
//                                 <p className={styles.detail}>
//                                     {/* <span className={styles.header}>2:21 PM</span> */}
//                                     {fraud?.id}

//                                 </p>
//                             </Grid>

//                             <Grid item md={2} xs={6} lg={4}>
//                                 <p className={styles.header}>Payment id</p>
//                                 <p className={styles.business}>
//                                     {fraud?.paymentid}

//                                 </p>
//                             </Grid>

//                             <Grid item md={3} xs={6} lg={3}>
//                                 <p className={styles.header}>Flag</p>
//                                 <p className={styles.detail}>
//                                     {fraud?.flag}

//                                 </p>
//                             </Grid>
//                             <Grid item md={2} xs={6} lg={4}>
//                                 <p className={styles.header}>Activity</p>
//                                 <p className={styles.detail}>
//                                     {/* {apiRes?.settlements[0]?.tradingname} */}
//                                     {fraud?.activity}

//                                 </p>
//                             </Grid>
//                             <Grid item md={2} xs={6} lg={2}>
//                                 <p className={styles.header}>Status</p>
//                                 <p className={styles.detail}>
//                                     {/* {apiRes?.settlements[0]?.tradingname} */}
//                                     {fraud?.status}

//                                 </p>
//                             </Grid>
//                             <Grid item md={2} xs={6} lg={2}>
//                                 <p className={styles.header}>Priority</p>
//                                 <p className={styles.detail}>
//                                     {/* {apiRes?.settlements[0]?.tradingname} */}
//                                     {fraud?.priority}

//                                 </p>
//                             </Grid>
//                             <Grid item md={2} xs={6} lg={2}>
//                                 <p className={styles.header}>Masked</p>
//                                 <p className={styles.detail}>
//                                     {/* {apiRes?.settlements[0]?.tradingname} */}
//                                     {fraud?.masked}

//                                 </p>
//                             </Grid>
//                             <Grid item md={2} xs={6} lg={2}>
//                                 <p className={styles.header}>Bin</p>
//                                 <p className={styles.detail}>
//                                     {/* {apiRes?.settlements[0]?.tradingname} */}
//                                     {fraud?.bin}

//                                 </p>
//                             </Grid>
//                             <Grid item md={2} xs={6} lg={2}>
//                                 <p className={styles.header}>Last4</p>
//                                 <p className={styles.detail}>
//                                     {/* {apiRes?.settlements[0]?.tradingname} */}
//                                     {fraud?.last4}

//                                 </p>
//                             </Grid>
//                             <Grid item md={2} xs={6} lg={2}>
//                                 <p className={styles.header}>Date</p>
//                                 <p className={styles.detail}>
//                                     {/* {apiRes?.settlements[0]?.tradingname} */}
//                                     {fraud?.createdat}

//                                 </p>
//                             </Grid>

//                         </Grid>
//                     </div>

//                     <h3>Customer</h3>
//                     <Grid container spacing={1}>
//                         <Grid item md={2} xs={6} lg={2}>
//                             <p className={styles.header}>Id</p>
//                             <p className={styles.detail}>
//                                 {/* {apiRes?.settlements[0]?.initiatedat} */}
//                                 {fraud?.id}

//                             </p>
//                         </Grid>

//                         <Grid item md={2} xs={6} lg={2}>
//                             <p className={styles.header}>first name</p>
//                             <p className={styles.detail}>
//                                 {/* {apiRes?.settlements[0]?.initiatedat} */}
//                                 {fraud?.customer?.firstname}
//                             </p>
//                         </Grid>
//                         <Grid item md={2} xs={6} lg={2}>
//                             <p className={styles.header}>Last name</p>
//                             <p className={styles.detail}>
//                                 {/* {apiRes?.settlements[0]?.initiatedat} */}
//                                 {fraud?.customer?.lastname}
//                             </p>
//                         </Grid>

//                         <Grid item md={3} xs={6} lg={3}>
//                             <p className={styles.header}>Email address</p>
//                             <p className={styles.detail}>
//                                 {/* {apiRes?.settlements[0]?.settlementid} */}
//                                 {fraud?.customer?.email}

//                             </p>
//                         </Grid>

//                         <Grid item md={2} xs={6} lg={3}>
//                             <p className={styles.header}>Identifier</p>
//                             <p className={styles.detail}>
//                                 {/* {apiRes?.settlements[0]?.amount} */}
//                                 {fraud?.customer?.identifier}

//                             </p>
//                         </Grid>

//                     </Grid>

//                     <div className={styles.mt1}>
//                         <h3>Business</h3>

//                         <Grid container spacing={1}>
//                             <Grid item md={2} xs={6} lg={2}>
//                                 <p className={styles.header}>Business email</p>
//                                 <p className={styles.detail}>
//                                     {/* <span className={styles.header}>2:21 PM</span> */}
//                                     {fraud?.business?.businessemail}

//                                 </p>
//                             </Grid>

//                             <Grid item md={2} xs={6} lg={2}>
//                                 <p className={styles.header}>Merchant code</p>
//                                 <p className={styles.business}>
//                                     {fraud?.business?.merchantcode}

//                                 </p>
//                             </Grid>

//                             <Grid item md={3} xs={6} lg={3}>
//                                 <p className={styles.header}>Trading name</p>
//                                 <p className={styles.detail}>
//                                     {fraud?.business?.tradingname}

//                                 </p>
//                             </Grid>
//                             <Grid item md={2} xs={6} lg={2}>
//                                 <p className={styles.header}>merchantcode</p>
//                                 <p className={styles.detail}>
//                                     {/* {apiRes?.settlements[0]?.tradingname} */}
//                                     {fraud?.business?.merchantcode}

//                                 </p>
//                             </Grid>

//                         </Grid>
//                     </div>

//                 </Box>
//             </div>
//         </div>
//     </Box>
// </div>
